// extracted by mini-css-extract-plugin
module.exports = {"root":"ukf9SLA7","flexColumn":"t2fLYjWh","titleLabel":"p_hoNDK3","subtitleLabel":"ItL4D6wn"};